/** Billing helpers shared by Settings → Billing and the banner in the app shell. */
import { api, useAction, useApi } from './api';
import { money } from './format';
import type { Billing, Plan } from './types';

/** The company's billing state. One query, shared by every caller. */
export const useBilling = () => useApi<Billing>('/api/billing', { staleTime: 60_000 });

/** Opens Dodo's hosted checkout, which returns to Settings → Billing with `?checkout=done`. Stays pending while the page leaves. */
export function useSubscribe() {
  const m = useAction(() => api<{ url: string }>('/api/billing/checkout', { method: 'POST' }));
  return { start: () => m.mutate(undefined, { onSuccess: ({ url }) => window.location.assign(url) }), pending: m.isPending || m.isSuccess };
}

/** Dodo's customer portal: card, invoices, cancelling. */
export function useManageBilling() {
  const m = useAction(() => api<{ url: string }>('/api/billing/portal', { method: 'POST' }));
  return { start: () => m.mutate(undefined, { onSuccess: ({ url }) => window.location.assign(url) }), pending: m.isPending || m.isSuccess };
}

/** "$99.00 / month", "$990.00 / year", "$30.00 every 3 months". */
export function planPrice(plan: Plan): { amount: string; per: string } {
  const unit = plan.interval.toLowerCase();
  const per = plan.intervalCount > 1 ? `every ${plan.intervalCount} ${unit}s` : `/ ${unit}`;
  return { amount: money(plan.price, plan.currency), per };
}

export const days = (n: number) => `${n} day${n === 1 ? '' : 's'}`;
